import StarterKit from '@tiptap/starter-kit';
import { TextStyleKit } from '@tiptap/extension-text-style';
import TextAlign from '@tiptap/extension-text-align';
import { normalizeLink } from './richText';
import { DescriptionImage } from './photo';

// Web / email links only (the server keeps the same: backend/services/rich_text.py).
export const LINK_RE = /^(https?:\/\/|mailto:)\S+$/i;

// The description editor's schema: only what the toolbar offers (pasted headings, code… become plain text).
// Links: a typed / pasted "www.x.com" autolinks too (stored as https://).
export const RICH_EXTENSIONS = [
  StarterKit.configure({
    heading: false, blockquote: false, code: false, codeBlock: false, horizontalRule: false, strike: false,
    link: {
      openOnClick: false, autolink: true, linkOnPaste: true, defaultProtocol: 'https',
      HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer nofollow' },
      isAllowedUri: (url) => LINK_RE.test(url) || !!normalizeLink(url),
    },
  }),
  TextStyleKit.configure({ backgroundColor: false, lineHeight: false }),
  TextAlign.configure({ types: ['paragraph'], alignments: ['left', 'center'] }),
  DescriptionImage,
];
